import { appConfig } from 'src/config';

export const SESSION_VALIDATION_URL = `${appConfig.URL_REST}user`;

const normalizeUrl = (url: string): string => {
  try {
    const parsedUrl = new URL(url, window.location.origin);
    return `${parsedUrl.origin}${parsedUrl.pathname.replace(/\/+$/, '')}`;
  } catch {
    return url.split(/[?#]/)[0].replace(/\/+$/, '');
  }
};

export const isSessionValidationRequest = (url?: string, method?: string): boolean => {
  if (!appConfig.URL_REST || !url || method?.toLowerCase() !== 'get') {
    return false;
  }

  return normalizeUrl(url) === normalizeUrl(SESSION_VALIDATION_URL);
};
